// Utils
import metrics from "../metrics";
import { getProductForSku } from "../planToProduct";

// Services
import intl from "../../services/intl";

export function trackProductPromotionViewed(sku) {
  metrics.track("Promotion Viewed", getProductPromotionAttributes(sku));
}

// TODO: Currently the promotion data isn't available when the promotion is
// viewed, it is only available when the promotion is added to cart. This should
// be refactored to be more dynamic once promotion data is queried on page load.
export function getProductPromotionAttributes(sku, productPromotionId) {
  const product = getProductForSku(sku);
  if (!product) return {};

  return {
    promotion_id: productPromotionId,
    name: product.name,
    product_name: product.name,
    image_url: product.imageUrl,
    sku,
    amount: 0,
    currency: intl.currency.type,
    discounted_price: "Free",
    type: "ProductPromotion",
  };
}
